import React from "react";

function BigNumber({ isLoading, count, title, styles, icon: Icon }) {
  return (
    <div
      className={`px-6 py-8 bg-gray-50 dark:bg-gray-800 rounded-lg ${
        styles ? styles : ""
      }`}
    >
      {Icon && (
        <Icon
          className="h-6 w-6 text-gray-400 dark:text-gray-500 mb-3"
          aria-hidden="true"
        />
      )}
      <h2 className="text-sm tracking-wide text-gray-500 dark:text-gray-400 pb-2">{title}</h2>
      <p>
        {isLoading ? (
          <span className="text-5xl font-bold text-gray-900 dark:text-white">...</span>
        ) : (
          <span className="text-5xl font-bold text-gray-900 dark:text-white">
            {String(count).padStart(2, "0")}
          </span>
        )}
      </p>
    </div>
  );
}

export { BigNumber };
